import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../../_redux/school-reports/SchoolReportsAction";
import * as uiHelpers from "../SchoolReportModulesUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../../../_metronic/_partials/controls";
import { useSchoolReportModulesUIContext } from "../SchoolReportModulesUIContext";

export function SchoolReportModulesTable({
  moduleValues,
  setModuleValues
}) {
  // School Report Modules UI Context
  const schoolReportModulesUIContext = useSchoolReportModulesUIContext();
  const schoolReportModulesUIProps = useMemo(() => {
    return {
      ids: schoolReportModulesUIContext.ids,
      setIds: schoolReportModulesUIContext.setIds,
      queryParams: schoolReportModulesUIContext.queryParams,
      setQueryParams: schoolReportModulesUIContext.setQueryParams,
      term: schoolReportModulesUIContext.term
    };
  }, [schoolReportModulesUIContext]);

  // Getting curret state of School Report Modules list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.schoolReports }),
    shallowEqual
  );
  const { totalCount, entities, moduleIds, modules, listLoading } = currentState;
  
  // School Report Modules Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    schoolReportModulesUIProps.setIds(moduleIds);
    if (schoolReportModulesUIProps.term && modules) dispatch(actions.getReportModules(schoolReportModulesUIProps.queryParams, modules));
    return () => dispatch(actions.cleanReportModulesState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleIds, schoolReportModulesUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "module",
      text: "Modül",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "order",
      text: "Sıra",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.OrderColumnFormatter,
      formatExtraData: {
        moduleValues,
        setModuleValues,
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: schoolReportModulesUIProps.queryParams.pageSize,
    page: schoolReportModulesUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                schoolReportModulesUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: schoolReportModulesUIProps.ids,
                setIds: schoolReportModulesUIProps.setIds
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}